// Copyright (c) Cosmo Tech.
// Licensed under the MIT license.

// Set here the logo and the login wallpaper url
export default {
  darkLogo: '/theme/cosmotech_dark_logo.png',
  lightLogo: '/theme/cosmotech_light_logo.png',
  auth: '/theme/authDark.png',
};
